import script from "./PageAnalyticsOrg.vue?vue&type=script&setup=true&lang=js"
export * from "./PageAnalyticsOrg.vue?vue&type=script&setup=true&lang=js"

import "./PageAnalyticsOrg.vue?vue&type=style&index=0&id=17ef02d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ef02d8"]])

export default __exports__